// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-audio {\n  text-transform: uppercase;\n  text-decoration: underline;\n  color: #4C1D95;\n  cursor: pointer;\n  font-size: 10px;\n}\n.create-meditation-content-wrap {\n  max-width: 1040px;\n}\n.form {\n  margin-top: 30px;\n}\n.form-border {\n  margin-bottom: 24px;\n  padding-bottom: 75px;\n  border-bottom: 1px solid #ced4de;\n}\n.form-item {\n  margin-bottom: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
